__turbopack_context__.v({
  "bottom-left-element": "ObjectCardImageGallery-module-scss-module__mj-ouq__bottom-left-element",
  "container": "ObjectCardImageGallery-module-scss-module__mj-ouq__container",
  "navigation": "ObjectCardImageGallery-module-scss-module__mj-ouq__navigation",
  "navigation-disabled": "ObjectCardImageGallery-module-scss-module__mj-ouq__navigation-disabled",
  "navigation-next": "ObjectCardImageGallery-module-scss-module__mj-ouq__navigation-next",
  "navigation-prev": "ObjectCardImageGallery-module-scss-module__mj-ouq__navigation-prev",
  "placeholder": "ObjectCardImageGallery-module-scss-module__mj-ouq__placeholder",
  "top-left-element": "ObjectCardImageGallery-module-scss-module__mj-ouq__top-left-element",
});
